<template>
  <div @click.prevent="goBack" class="auth-mobile-button" v-if="isVisible">
    <i class="demo-icon icon-back" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "BackComponent",
  props: [],
  computed: {
    ...mapGetters('auth', {
      currentComponent: 'getCurrentComponent',
    }),
    isVisible() {
      return this.currentComponent
        && this.currentComponent !== 'auth-welcome-card'
        && this.currentComponent !== 'auth-registration-success-card';
    },
  },
  methods: {
    goBack() {
      this.$eventHub.$emit('AuthGoBack')
    }
  },
}
</script>
<style scoped>
</style>
